import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';

/**
 * Scaffolded from day one per CLAUDE.md §10, with `en` the only translated
 * language at go-live (open question Q23). `ms` and `zh` resource files drop in
 * beside `en.json` without touching a component, because nothing renders a
 * hardcoded user-facing string.
 */
void i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'ms', 'zh'],
  interpolation: { escapeValue: false },
});

export default i18n;
